<template>
  <div class="login-overlay" @click.self="$emit('close')">
    <div class="profile-card">

      <div class="login-header">
        <h2>{{ t('partnerProfile') }}</h2>
        <button class="close-btn" @click="$emit('close')">&#10005;</button>
      </div>

      <div class="profile-body">
        <ChatProfileForm
            :service="service"
            :connectionId="connectionId"
            :showAdminFields="true"
            @saved="$emit('saved', $event)"
        />
      </div>

      <div class="profile-footer">
        <button class="secondary-btn" @click="$emit('close')">{{ t('close') }}</button>
      </div>

    </div>
  </div>
</template>

<script>
import { useI18n } from "../i18n.js"
import ChatProfileForm from "./ChatProfileForm.vue"

export default {
  name: "ChatConnectionUser",

  components: { ChatProfileForm },

  props: {
    service: { type: Object, required: true },
    connectionId: { type: [String, Number], required: true }
  },

  emits: ['close', 'saved'],

  setup() {
    const { t } = useI18n()
    return { t }
  }
}
</script>

<style scoped>
.login-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.profile-card {
  width: min(560px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.login-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e8ee;
}

.login-header h2 { margin: 0; font-size: 18px; }

.close-btn {
  border: none;
  background: none;
  font-size: 20px;
  cursor: pointer;
  color: #666;
}
.close-btn:hover { color: #000; }

.profile-body {
  padding: 20px;
  overflow-y: auto;
}

.profile-footer {
  padding: 12px 20px;
  border-top: 1px solid #e4e8ee;
  display: flex;
  justify-content: flex-end;
}

.secondary-btn {
  padding: 9px 16px;
  background: #f0f2f5;
  color: #1a1a2e;
  border: none;
  border-radius: 8px;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
}

.secondary-btn:hover { background: #e4e8ee; }
</style>
